import { DateTime } from 'luxon';

import { loadLuxonDateTime } from '@rygen/rygen-ui/util';

import { ShipmentStopType } from '../shipment/ShipmentStopType';

import { ShipmentEventEquipment } from './ShipmentEventEquipment';
import { ShipmentEventLocation } from './ShipmentEventLocation';
import { ShipmentEventSeverity } from './ShipmentEventSeverity';

export class ShipmentServiceIncident {
  id?: number;
  shipmentId?: number;
  relatedStopId?: number;
  stopType?: ShipmentStopType;
  incidentType?: string;
  severity?: ShipmentEventSeverity;
  actualLocation: ShipmentEventLocation = new ShipmentEventLocation();
  actualDate?: DateTime;
  equipments: ShipmentEventEquipment[] = [];
  comment?: string;
  carrierId?: number;

  constructor(opts?: Partial<ShipmentServiceIncident>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.relatedStopId != null) {
      this.relatedStopId = opts.relatedStopId;
    }
    if (opts?.stopType != null) {
      if (typeof opts?.stopType === 'string') {
        this.stopType = ShipmentStopType[opts.stopType];
      } else {
        this.stopType = opts.stopType;
      }
    }
    if (opts?.incidentType != null) {
      this.incidentType = opts.incidentType;
    }
    if (opts?.severity != null) {
      if (typeof opts?.severity === 'string') {
        this.severity = ShipmentEventSeverity[opts.severity];
      } else {
        this.severity = opts.severity;
      }
    }
    if (opts?.actualLocation != null) {
      this.actualLocation = new ShipmentEventLocation(opts.actualLocation);
    }
    this.actualDate = loadLuxonDateTime(
      opts?.actualDate,
      opts?.actualLocation?.timeZone,
    );
    if (opts?.equipments != null) {
      this.equipments = opts.equipments.map(
        (val) => new ShipmentEventEquipment(val),
      );
    }
    if (opts?.comment != null) {
      this.comment = opts.comment;
    }
    if (opts?.carrierId != null) {
      this.carrierId = opts.carrierId;
    }
  }
}
